import { Identifiable, RecordModel } from "../core";
import { EditOutlined, RetweetOutlined } from "@ant-design/icons";
import { Form } from "antd";
import ModalSelect from "../../components/fields/ModalSelect";
import { GalleryImageModel } from "./generics";
import IframeWithLoader from "../../components/business/BrochureIframe";

const FormItem = Form.Item;

export const awdwad = 123;

export interface ISalesMaterialConfig extends Identifiable {
  unit: number;
  unit_name: string;
  resource_slug: string;
  material_type: "brochure" | "sip";
  material_type_display: string;
  identifier: string;
  is_active: boolean;
  slides: number[];
  slides_count: number;
  created_at: string;
  modified_at: string;
}

export interface ISalesMaterialSlide extends Identifiable {
  "config": number,
  //"config_unit_name": string,
  //"config_material_type": "brochure" | "sip",
  //"config_identifier": string,
  "slide_identifier": string,
  "slide_type": "default" | "custom",
  //"slide_type_display": string,
  "position": number,
  "enabled": boolean,
  "custom_image": string | null,
  //"has_custom_image": boolean
}

export interface ISalesRepresentative extends Identifiable {
  name: string;
  email: string;
  phone: string;
  profile_image: string | null;
  calendar_link: string;
  is_active: boolean;
  is_public: boolean;
  created_at: string;
  modified_at: string;
}

export const SalesMaterialConfigModel: RecordModel<ISalesMaterialConfig> = {
  name: "Sales Material Config",
  path: "sales-material-configs",
  selectQuery: "",
  tableQuery: "",
  toString: r => `${r.identifier} ${r.unit_name} ${r.material_type}`,
  fieldModels: {
    slides: 'SalesMaterialSlide'
  },
  customActions: [
    {
      name: 'Recreate',
      path: 'resync',
      method: 'post',
      icon: <RetweetOutlined />,
      isDetail: true,
      confirmationMessage: "If you continue, the brochure will be re-created from scratch. Current edits will be lost. Are you sure you want to proceed?",
      hidden: (record) => !!record ? record.is_active : false,
    },
    {
      name: 'Edit',
      path: 'publish',
      method: 'post',
      icon: <EditOutlined />,
      isDetail: true,
      // hidden: (record) => !!record ? record.is_active : false,
      confirmationProps: (record) => ({
        title: 'Brochure editor',
        okText: record.is_active ? 'Save' : 'Publish',
        width: '100vw',
        height: '100vh',
        style: { top: '0', maxWidth: '100%' },
        body: (
          <IframeWithLoader
            src={`${process.env.REACT_APP_ANCANA_SITE_URL}/brochure/${record.resource_slug}?bypassForReview=true&unit=${record.unit}&type=${record.material_type}`}
            title="Brochure Review"
            config={record}
            recordModel={SalesMaterialSlideModel}
          />
        ),
      }),
    },
  ],
}

export const SalesMaterialSlideModel: RecordModel<ISalesMaterialSlide> = {
  name: "Sales Material Slide",
  path: "sales-material-slides",
  selectQuery: "",
  tableQuery: "&expand=config",
  toString: r => r.slide_identifier,
  useMultipartFormData: true,
  fieldModels: {
    config: 'SalesMaterialConfig',
    images: 'GalleryImages'
  },
  customTableMappings: {
    ...Object.fromEntries(['created_at', 'modified_at', 'title', 'body', 'images', 'categorized_amenities', 'custom_image'].map(fieldName => ([fieldName, { omit: true }]))),
    position: { width: 72 },
    slide_type: { title: 'Type', width: 70 },
  },
  customCreateFields: [
    { name: 'images', component: (props) => <ModalSelect recordModel={GalleryImageModel} label="Images" formName={props.formName} /> },
  ],
  dependentFields: {
    images: {
      dependsOn: 'config',
      valuePath: ['config', 'unit'],
      filterName: 'unit'
    }
  }
}

export const SalesRepresentativeModel: RecordModel<ISalesRepresentative> = {
  name: "Sales Representative",
  path: "sales-representatives",
  selectQuery: "",
  tableQuery: "",
  toString: r => r.name,
  useMultipartFormData: true,
}
